import React, { PropsWithChildren } from 'react';

import { Heading2 } from '@common/Typography';

interface Props {
  order?: number;
}

export default function SectionHeader({
  children,
  order,
}: PropsWithChildren<Props>) {
  return (
    <Heading2>
      <div className="flex flex-row items-end mb-4">
        {order !== undefined && (
          <span className="mr-6 text-brand-500">{order}</span>
        )}
        {children}
      </div>
    </Heading2>
  );
}
